// import { GET_RATECARD } from "resources/actionTypes";

// export function getRateCard(data) {
//   return {
//     type: GET_RATECARD.GET_RATECARD_REQUESTED,
//     payload: data
//   };
// }

// export function clearRateCard(data) {
//   return {
//     type: GET_RATECARD.GET_RATECARD_CLEARED
//   };
// }
import { GET_ADDRATECARD, GET_RATECARD, GET_TRIPPRICE, GET_COMPANYDUTY, GET_COMPANYLOCATION, GET_SUBCITY } from "resources/actionTypes"

export function getRateCard(data) {
  return {
    type: GET_RATECARD.GET_RATECARD_REQUESTED,
    payload: data
  };
}

export function postRateCard(userAddRateCard) {
  const data = {
    userAddRateCard: userAddRateCard,
  }
  return {
    type: GET_ADDRATECARD.GET_ADDRATECARD_REQUESTED,
    payload: data
  }
}

export function getTripPrice(userGetTrip) {
  const data = {
    userGetTrip: userGetTrip,
  }
  return {
    type: GET_TRIPPRICE.GET_TRIPPRICE_REQUESTED,
    payload: data
  }
}

export function getCompanyLocation(data) {
  return {
    type: GET_COMPANYLOCATION.GET_COMPANYLOCATION_REQUESTED,
    payload: data
  };
}

export function getCompanyDuty(data, type, setFilterValues, filterValues, setSubCityStatus) {

  const payloadData = {
    data: data, 
    type: type,
    setFilterValues: setFilterValues,
    filterValues: filterValues,
    setSubCityStatus: setSubCityStatus
  }
  return {
    type: GET_COMPANYDUTY.GET_COMPANYDUTY_REQUESTED,
    payload: payloadData
  };
}

export function clearCompanyLocation() {
  return {
    type: GET_COMPANYLOCATION.GET_COMPANYLOCATION_CLEAR,
  };
}

export function clearCompanyDuty() {
  return {
    type: GET_COMPANYDUTY.GET_COMPANYDUTY_CLEAR,
  };
}

export function clearRateCard() {
  return {
    type: GET_RATECARD.GET_RATECARD_CLEAR,
  };
}

export function getSubCity(data, type, setFilterValues, filterValuesData) {

  const payloadData = {
    id: data,
    type: type,
    setFilterValues: setFilterValues,
    filterValues: filterValuesData
  }
  return {
    type: GET_SUBCITY.GET_SUBCITY_REQUESTED,
    payload: payloadData
  };
}

export function clearSubCity() {
  return {
    type: GET_SUBCITY.GET_SUBCITY_CLEAR,
  };
}


